import { Injectable } from '@angular/core';
import { BackendService } from 'app/backend.service';
import { Observable } from 'rxjs';

@Injectable()
export class ApiDataService {

  constructor(private backendService: BackendService) { }

  getFaqs(): Observable<any> {
    return this.backendService.getData('/preapproveFaqs.json', null, false, true, true);
  }

  getNewGCVoucherGenerationSwitch(): Observable<any> {
    return this.backendService.getData('/NewGCVoucherGenFlow.json', null, false, true, true);
  }

  getVoucherRedemptionDetails(merchant: string): Observable<any> {
    return this.backendService.getData(`/voucher-redemption-details/${merchant.toLowerCase()}.json`, null, false, true, true);
  }

  getInsuranceFee(loanId, merchantId, loanAmount, tenure): Observable<any> {
    return this.backendService.getData(`/insurance/api/v2/loans/${loanId}/merchant/${merchantId}?loanAmount=${loanAmount}&tenure=${tenure}`);
  }

}
